import { render, staticRenderFns } from "./DocumentsWidgetIcon.vue?vue&type=template&id=3a54235c"
import script from "./DocumentsWidgetIcon.vue?vue&type=script&lang=js"
export * from "./DocumentsWidgetIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports